// extracted by mini-css-extract-plugin
export default {"Linkers":"footer_Linkers__hfdX7","socialIcons":"footer_socialIcons__Yva3y","footerOne":"footer_footerOne__SP56g"};